import { render, staticRenderFns } from "./LeadCenterWorkflows.vue?vue&type=template&id=718b60af&scoped=true&"
import script from "./LeadCenterWorkflows.vue?vue&type=script&lang=js&"
export * from "./LeadCenterWorkflows.vue?vue&type=script&lang=js&"
import style0 from "./LeadCenterWorkflows.vue?vue&type=style&index=0&id=718b60af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718b60af",
  null
  
)

export default component.exports